import { render, staticRenderFns } from "./step1-dt.vue?vue&type=template&id=d070f6d8&scoped=true&"
import script from "./step1-dt.vue?vue&type=script&lang=js&"
export * from "./step1-dt.vue?vue&type=script&lang=js&"
import style0 from "./step1-dt.vue?vue&type=style&index=0&id=d070f6d8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d070f6d8",
  null
  
)

export default component.exports